import { BASE_URL, HTTP_METHODS } from "../App/Configs/AppConfigs";
import ApiHelper from "../App/Utils/ApiHelper";
import { MATERIAL_TRACKING_BASE_API_PATH } from "./Constants";

export class DataProvider {
  apiHelper = new ApiHelper(BASE_URL + MATERIAL_TRACKING_BASE_API_PATH);
  masterApiHelper = new ApiHelper(BASE_URL + "/master");

  getDropdownValues = async (model, value) => {
    const url = value?'/masters.'+model+'/list?is_active=True&filter=1&page=1&pageSize=100000' + value:
      '/masters.'+model+'/list?is_active=True&filter=1&page=1&pageSize=100000' 
    return await this.masterApiHelper.apiCall(url, HTTP_METHODS.GET, null);
  };

  getDependentDropdownValues = async (model, filter) => {
    return await this.masterApiHelper.apiCall('/masters.'+model+"/list?is_active=True&page=1&pageSize=100000&filter=1&"+filter, HTTP_METHODS.GET, null);
  };

  submitPackage = async (payload) => {
    return await this.apiHelper.apiCall('/', HTTP_METHODS.POST, payload);
  };

  updatePackage = async (packingId, payload) => {
    return await this.apiHelper.apiCall('/' + packingId, HTTP_METHODS.PUT, payload);
  };

  assignQRCode = async (packingId, payload) => {
    return await this.apiHelper.apiCall('/' + packingId, HTTP_METHODS.PATCH, payload);
  };

  getPackageList = async (values) => {
    return await this.apiHelper.apiCall('/' + values, HTTP_METHODS.GET, null);
  };

  getPackageInfo = async (package_id) => {
    return await this.apiHelper.apiCall('/' + package_id, HTTP_METHODS.GET, null);
  };

}
